import ReactDOM from "react-dom";
import App from "./app";

import { QueryClient, QueryClientProvider } from "react-query";
import { ConfigProvider } from "antd";
import { AuthProvider } from "./hooks/useAuth";
import { DomLoadedProvider } from "./hooks/DomLoadedContext";
import { useEffect } from "react";
// import posthog from 'posthog-js'
// // posthog.init('phc_xW4lt1dX1Soksy1r2BeeD9bnpjPiPx0DH9BPaybsG1T', { api_host: 'https://app.posthog.com' })
//    // Detect Safari and apply special handling
//    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//    if (isSafari) {
//      posthog.init("phc_xW4lt1dX1Soksy1r2BeeD9bnpjPiPx0DH9BPaybsG1T", {
//        api_host: "https://app.posthog.com",
//        request_batching: false, // Disable batching completely for Safari
//        transport: 'XHR' // Use XHR instead of Beacon
//      });
//    }
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: true,
			refetchOnMount: true,
			refetchOnReconnect: true,
			retry: 1,
			// staleTime: 5 * 60 * 1000, // 5 minutes
			// cacheTime: 10 * 60 * 1000, // 10 minutes
		},
	},
});

ReactDOM.render(
	<QueryClientProvider client={queryClient}>
		<AuthProvider>
			<DomLoadedProvider>
				<ConfigProvider
					theme={{
						token: {
							colorPrimary: "black",
						},
					}}
				>
					<App />
				</ConfigProvider>
			</DomLoadedProvider>
		</AuthProvider>
	</QueryClientProvider>,

	document.getElementById("root")
);
